module.exports = __webpack_public_path__ + "media/Video 2.ea167d6d.mp4";